<template>
    <select class="form-select" :aria-label="title">
        <option v-for="option in options" :key="option.value" :value="option.value">{{ option.title }}</option>
    </select>
</template>

<script>
export default {
    name: "FormSelect",
    props: {
        title: {
            type: String,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
